// apps/web/src/main.tsx
//
// React 19 root mount + StrictMode + TanStack Query provider.
// AppRouter (from src/router.tsx) is consumed inside src/App.tsx so the smoke
// test can wrap the same App in MemoryRouter without colliding with this entry.
//
// Plan 08-10: Sonner <Toaster /> is mounted at the app root so toast.error()
// calls from any page (RecipeEditor save flow, paste-JSON sanitization
// failures, network-failure fallbacks) render into a singleton portal at
// top-center. The Toaster is placed OUTSIDE QueryClientProvider so the
// portal does not re-mount when the query cache resets.
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { Toaster } from "./components/ui/sonner";
import "./styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Sensible defaults; Plan 12b refines per-endpoint as needed.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found in index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
    <Toaster richColors position="top-center" />
  </StrictMode>,
);
